import React, { useState, useEffect } from 'react'
import {
  Panel,
  Radio,
  RadioGroup,
  Row,
  Col,
  ControlLabel,
  CheckboxGroup,
  Checkbox,
  DatePicker,
  Message,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import { updateCloseOfProjectStaffForm } from '../../redux/actions/closeOfProject'
import AttachFilesCloseProjectStaffWidget from './AttachFilesCloseProjectStaffWidget'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import CustomMessages from '../../components/message/CustomMessages'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import ClosureAttachmentWidget from '../closureAttachmentWidget/ClosureAttachmentWidget'

export default function CloseProjectStaffWidget({
  schema: _schema,
  evaluationId,
  onSuccess = () => {},
  ...props
}) {
  const { showCommandButton, isEditAll, isApprove, schemaEvaluate, evaluateDisabled } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, unregister } =
    useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [formSchemaEvaluate, setFormSchemaEvaluate] = useState(schemaEvaluate)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [otherDocumentSelected, setOtherDocumentSelected] = useState(false)
  const [otherDocumentValue, setOtherDocumentValue] = useState('')
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)

  const [autoVerify, setAutoVerify] = useState(false)

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    if (formSchema?.actualPeriod?.actualStartDate && formSchema?.actualPeriod?.actualEndDate) {
      setStartDate(
        formSchema.actualPeriod.actualStartDate.value
          ? moment(formSchema.actualPeriod.actualStartDate.value).toDate()
          : ''
      )
      setEndDate(
        formSchema.actualPeriod.actualEndDate.value
          ? moment(formSchema.actualPeriod.actualEndDate.value).toDate()
          : ''
      )
      setValue(
        formSchema.actualPeriod.actualStartDate.name,
        formSchema.actualPeriod.actualStartDate.value
          ? moment(formSchema.actualPeriod.actualStartDate.value).toDate()
          : ''
      )
      setValue(
        formSchema.actualPeriod.actualEndDate.name,
        formSchema.actualPeriod.actualEndDate.value
          ? moment(formSchema.actualPeriod.actualEndDate.value).toDate()
          : ''
      )
    }
  }, [_schema])

  useEffect(() => {
    if (
      !formSchemaEvaluate.evaluateQuality.value ||
      formSchemaEvaluate.evaluateQuality.value?.length === 0
    ) {
      setValue(formSchemaEvaluate.evaluateQuality.name)
    }

    if (
      !formSchemaEvaluate.evaluateCompareGoal.value ||
      formSchemaEvaluate.evaluateCompareGoal.value?.length === 0
    ) {
      setValue(formSchemaEvaluate.evaluateCompareGoal.name)
    }

    if (!formSchemaEvaluate.dataSource.value || formSchemaEvaluate.dataSource.value?.length === 0) {
      setValue(formSchemaEvaluate.dataSource.name)
    }

    if (!formSchemaEvaluate.document.value || formSchemaEvaluate.document.value?.length === 0) {
      setValue(formSchemaEvaluate.document.name)
    } else {
      const isOther = formSchemaEvaluate.document.value.find((item) => item === 4)
      if (isOther) {
        setOtherDocumentSelected(true)
        setOtherDocumentValue(formSchemaEvaluate.other?.value)
        setValue(formSchemaEvaluate.other?.name, formSchemaEvaluate.other?.value)
      }
    }
  }, [schemaEvaluate])

  const onSubmit = (data) => {
    // console.log('onSubmit data', data)
    // console.log('formSchema', formSchema)

    let request = {
      projectVersionId: projectId,
      value: data[formSchema.note.name] || '',
      approveType: isApprove ? data[formSchema.approveType.name] : 0,

      note: data[formSchema.note.name] || '',
      summaryOfWork: data[formSchema.summaryOfWork.name] || '',
      summaryOfBudget: data[formSchema.summaryOfBudget.name] || '',
      followUpComment: data[formSchema.followUpComment.name] || '',
      actualStartDate: data[formSchema.actualPeriod.actualStartDate.name]
        ? data[formSchema.actualPeriod.actualStartDate.name].toISOString()
        : '',
      actualEndDate: data[formSchema.actualPeriod.actualEndDate.name]
        ? data[formSchema.actualPeriod.actualEndDate.name].toISOString()
        : '',
      evaluateCompareGoal: data[formSchemaEvaluate.evaluateCompareGoal.name] || 0,
      evaluateQuality: data[formSchemaEvaluate.evaluateQuality.name] || 0,
      dataSource: data[formSchemaEvaluate.dataSource.name] || [],
      document: data[formSchemaEvaluate.document.name] || [],
      other: otherDocumentValue,
      sendToGrantee: sendToGranteeVal,
      noteSendToGrantee: data?.noteSendToGrantee || '',
    }
    setRequest(request)
    // console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateCloseOfProjectStaffForm(projectId, request)
      console.log('response', response)
      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const onValidateSubmit = (data) => {
    setAutoVerify(true)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchemaEvaluate.header}
        eventKey={1}
        collapsible
        defaultExpanded
        style={{ marginBottom: 20 }}
      >
        {formSchemaEvaluate.evaluateCompareGoal && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.evaluateCompareGoal.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.evaluateCompareGoal.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.evaluateCompareGoal.name]} />
            <Controller
              key={formSchemaEvaluate.evaluateCompareGoal.name}
              name={formSchemaEvaluate.evaluateCompareGoal.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.evaluateCompareGoal.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.evaluateCompareGoal.validators : null
              )}
              defaultValue={formSchemaEvaluate.evaluateCompareGoal.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchemaEvaluate.evaluateCompareGoal?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
            <br />
          </>
        )}

        {formSchemaEvaluate.evaluateQuality && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.evaluateQuality.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.evaluateQuality.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.evaluateQuality.name]} />
            <Controller
              key={formSchemaEvaluate.evaluateQuality.name}
              name={formSchemaEvaluate.evaluateQuality.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.evaluateQuality.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.evaluateQuality.validators : null
              )}
              defaultValue={formSchemaEvaluate.evaluateQuality.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchemaEvaluate.evaluateQuality?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
            <br />
          </>
        )}

        {formSchemaEvaluate.dataSource && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.dataSource.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.dataSource.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.dataSource.name]} />
            <Controller
              key={formSchemaEvaluate.dataSource.name}
              name={formSchemaEvaluate.dataSource.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.dataSource.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.dataSource.validators : null
              )}
              defaultValue={formSchemaEvaluate.dataSource.value}
              render={(props) => {
                return (
                  <CheckboxGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      if (value.length === 0) setValue(formSchemaEvaluate.dataSource.name)
                    }}
                  >
                    {formSchemaEvaluate.dataSource?.options?.map((item) => {
                      return (
                        <Checkbox value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Checkbox>
                      )
                    })}
                  </CheckboxGroup>
                )
              }}
            />
            <br />
          </>
        )}

        {formSchemaEvaluate.document && (
          <>
            <ControlLabel
              className={classNames(
                isRequired(formSchemaEvaluate.document.validators) && 'required'
              )}
            >
              {formSchemaEvaluate.document.label}
            </ControlLabel>
            <ErrorMessage error={errors[formSchemaEvaluate.document.name]} />
            <Controller
              key={formSchemaEvaluate.document.name}
              name={formSchemaEvaluate.document.name}
              control={control}
              // rules={isValidators(formSchemaEvaluate.document.validators)}
              rules={isValidators(
                !sendToGranteeVal ? formSchemaEvaluate.document.validators : null
              )}
              defaultValue={formSchemaEvaluate.document.value}
              render={(props) => {
                return (
                  <CheckboxGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      if (value.length === 0) setValue(formSchemaEvaluate.document.name)

                      if (value.find((item) => item == 4)) {
                        setOtherDocumentSelected(true)
                      } else {
                        setOtherDocumentSelected(false)
                      }
                    }}
                  >
                    {formSchemaEvaluate.document?.options?.map((item) => {
                      return (
                        <Checkbox value={item.value} disabled={evaluateDisabled}>
                          {item.label}{' '}
                        </Checkbox>
                      )
                    })}
                    {otherDocumentSelected && (
                      <div>
                        <ErrorMessage error={errors[formSchemaEvaluate.other.name]} />
                        <Input
                          name={formSchemaEvaluate.other.name}
                          inputRef={register(isValidators(formSchemaEvaluate.other.validators))}
                          disabled={evaluateDisabled}
                          placeholder={'เอกสารประกอบอื่นๆ'}
                          defaultValue={otherDocumentValue}
                          onChange={(value) => {
                            setOtherDocumentValue(value)
                            setValue(formSchemaEvaluate.other.name, value)
                          }}
                        />
                      </div>
                    )}
                  </CheckboxGroup>
                )
              }}
            />
            <br />
          </>
        )}
      </Panel>

      <Panel
        shaded
        header={formSchema.header}
        eventKey={2}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema?.note &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.note}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
                notValidate={sendToGranteeVal ? true : false}
              />
            </>
          ) : (
            // )
            <>
              <p>{formSchema.note.label}</p>
              {/* <p style={{ textIndent: '2.5em' }}>{formSchema.note.value || '- ไม่ระบุ -'}</p> */}
              <div
                style={{ wordWrap: 'break-word', marginLeft: 30, marginTop: 10 }}
                dangerouslySetInnerHTML={{ __html: formSchema.note.value }}
              />
            </>
          ))}

        <br />

        {formSchema?.summaryOfWork &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.summaryOfWork}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
                notValidate={sendToGranteeVal ? true : false}
              />
            </>
          ) : (
            // )
            <>
              <p>{formSchema.summaryOfWork.label}</p>
              <div
                style={{ wordWrap: 'break-word', marginLeft: 30, marginTop: 10 }}
                dangerouslySetInnerHTML={{ __html: formSchema.summaryOfWork.value }}
              />
            </>
          ))}

        <br />

        {formSchema?.summaryOfBudget &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.summaryOfBudget}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
                notValidate={sendToGranteeVal ? true : false}
              />
            </>
          ) : (
            <>
              <p>{formSchema.summaryOfBudget.label}</p>
              <div
                style={{ wordWrap: 'break-word', marginLeft: 30, marginTop: 10 }}
                dangerouslySetInnerHTML={{ __html: formSchema.summaryOfBudget.value }}
              />
            </>
          ))}

        <br />

        {formSchema?.followUpComment &&
          (showCommandButton ? (
            <>
              <CKEditorBlankFrom
                schema={formSchema?.followUpComment}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideToolbar={true}
              />
            </>
          ) : (
            <>
              <p>{formSchema.followUpComment.label}</p>

              <div
                style={{ wordWrap: 'break-word', marginLeft: 30, marginTop: 10 }}
                dangerouslySetInnerHTML={{ __html: formSchema.followUpComment.value }}
              />
            </>
          ))}

        <br />

        {formSchema.closeDate && (
          <div style={{ marginBottom: 20 }}>{formSchema.closeDate.label}</div>
        )}

        {formSchema.actualPeriod && (
          <>
            {!showCommandButton ? (
              <>
                {formSchema.actualPeriod?.actualStartDate?.label -
                  formSchema.actualPeriod?.actualEndDate?.label}
                <p style={{ textIndent: '2.5em' }}>
                  {new Date(formSchema.actualPeriod?.actualStartDate?.value).toLocaleDateString()} -{' '}
                  {new Date(formSchema.actualPeriod?.actualEndDate?.value).toLocaleDateString()}
                </p>
              </>
            ) : (
              <Row>
                <Col style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[formSchema.actualPeriod.actualEndDate.name]} />
                </Col>
                <Col style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[formSchema.actualPeriod.actualStartDate.name]} />
                </Col>

                {formSchema.actualPeriod.actualStartDate && (
                  <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 210 }}>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.actualPeriod.actualStartDate.validators,
                        formSchema.actualPeriod.actualStartDate.label
                      )}
                    </ControlLabel>
                    <Controller
                      key={formSchema.actualPeriod.actualStartDate.name}
                      name={formSchema.actualPeriod.actualStartDate.name}
                      control={control}
                      rules={isValidators(
                        !sendToGranteeVal
                          ? formSchema.actualPeriod.actualStartDate.validators
                          : null
                      )}
                      value={startDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            disabled={isEdit}
                            style={{ width: '100%' }}
                            format={DATE_PICKER_FORMAT}
                            placeholder={formSchema.actualPeriod.actualStartDate.label}
                            locale={LOCAL_DAY_TH}
                            //defaultValue={startDate}
                            value={startDate}
                            // disabled={isEdit || !showCommandButton}
                            onChange={(value) => {
                              props.onChange(value)
                              setStartDate(value)
                              //setValue(formSchema.actualPeriod.actualStartDate.name, value)
                            }}
                            disabledDate={(date) =>
                              getValues(formSchema.actualPeriod.actualEndDate.name) &&
                              moment(
                                getValues(formSchema.actualPeriod.actualEndDate.name)
                              ).isBefore(date, new Date())
                            }
                          />
                        )
                      }}
                    />
                  </Col>
                )}

                {formSchema.actualPeriod.actualEndDate && (
                  <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 210 }}>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.actualPeriod.actualEndDate.validators,
                        formSchema.actualPeriod.actualEndDate.label
                      )}
                    </ControlLabel>
                    <Controller
                      key={formSchema.actualPeriod.actualEndDate.name}
                      name={formSchema.actualPeriod.actualEndDate.name}
                      control={control}
                      rules={isValidators(
                        !sendToGranteeVal ? formSchema.actualPeriod.actualEndDate.validators : null
                      )}
                      value={endDate}
                      render={(props) => {
                        return (
                          <DatePicker
                            disabled={isEdit}
                            style={{ width: '100%' }}
                            format={DATE_PICKER_FORMAT}
                            placeholder={formSchema.actualPeriod.actualEndDate.label}
                            locale={LOCAL_DAY_TH}
                            //defaultValue={endDate}
                            value={endDate}
                            onChange={(value) => {
                              props.onChange(value)
                              setEndDate(value)
                              //setValue(formSchema.actualPeriod.actualEndDate.name, value)
                            }}
                            disabledDate={(date) =>
                              getValues(formSchema.actualPeriod.actualStartDate.name) &&
                              moment(
                                getValues(formSchema.actualPeriod.actualStartDate.name)
                              ).isAfter(date, new Date())
                            }
                          />
                        )
                      }}
                    />
                  </Col>
                )}
              </Row>
            )}
            <br />
          </>
        )}

        {/* แนบไฟล์ ปิดโครงการ ตามประเภท (ใหม่) */}
        {formSchema?.closureAttachment && (
          <>
            <br />
            <ClosureAttachmentWidget
              disabledForm={!showCommandButton || formSchema?.closureAttachment.disabled}
              schema={formSchema?.closureAttachment}
              //onUploadSuccess={(e) => setClosureAttachmentNew(e)}
            />
            <br />
          </>
        )}

        {/* {formSchema?.uploadDocuments && (
          <>
            <AttachFilesCloseProjectStaffWidget
              showCommandButton={showCommandButton}
              schema={formSchema.uploadDocuments}
            />
          </>
        )} */}

        {!evaluateDisabled && (
          <>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 30 }}>
                <Checkbox
                  defaultChecked={formSchema?.sendToGrantee?.value || sendToGranteeVal}
                  onChange={(_, checked, e) => {
                    console.log('checked ', checked)
                    setSendToGranteeVal(checked)
                  }}
                >
                  {formSchema?.sendToGrantee?.label}
                </Checkbox>
              </Col>
              {sendToGranteeVal && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                  <>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema?.noteSendToGrantee?.validators,
                        formSchema?.noteSendToGrantee?.label
                      )}
                    </ControlLabel>
                    <ErrorMessage error={errors[formSchema?.noteSendToGrantee?.name]} />
                    <Input
                      name={formSchema?.noteSendToGrantee?.name}
                      inputRef={register(isValidators(formSchema?.noteSendToGrantee?.validators))}
                      rows={3}
                      placeholder={formSchema?.noteSendToGrantee?.hint}
                      componentClass="textarea"
                      style={{ marginTop: 5 }}
                      defaultValue={formSchema?.noteSendToGrantee?.value}
                      disabled={formSchema?.noteSendToGrantee?.disabled}
                    />
                  </>
                </Col>
              )}
            </Row>
          </>
        )}

        {showCommandButton && (
          <>
            <hr />

            {isError && <Message showIcon type="error" description={isError} />}
            {isError && <Message showIcon type="error" description={isError} />}
            {!sendToGranteeVal && evaluationId && (
              <Message
                showIcon
                type="error"
                description={'กรุณาทำการประเมินปิดโครงการ'}
                style={{ marginBottom: 10 }}
              />
            )}

            {formSchema?.alert && <CustomMessages datas={formSchema?.alert?.values} />}

            {sendToGranteeVal ? (
              <EditButton
                onClick={handleSubmit(onSubmit)}
                disabled={!sendToGranteeVal && evaluationId}
                icon="send-o"
                children={formSchema?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'}
              />
            ) : (
              <>
                <ApproverList
                  approveType={9}
                  projectversionId={projectId}
                  style={{ marginLeft: 10, marginBottom: 10, marginRight: 10 }}
                  disabled={(!sendToGranteeVal && evaluationId) || formSchema?.alert?.disabled}
                  buttontext={'ตรวจสอบสายอนุมัติและ' + formSchema.buttonText}
                  isLoading={isLoading}
                  callCheck={autoVerify}
                  setCallCheck={setAutoVerify}
                  onValidateForm={handleSubmit(onValidateSubmit)}
                  fetchButton={(disabled) => (
                    <SaveButton
                      onClick={handleSubmit(onSubmit)}
                      disabled={
                        (!sendToGranteeVal && evaluationId) ||
                        formSchema?.alert?.disabled ||
                        disabled
                      }
                      icon="send-o"
                      style={{ marginBottom: 10 }}
                    >
                      {formSchema.buttonText}
                    </SaveButton>
                  )}
                />
              </>
            )}
          </>
        )}

        {formSchema?.checkButton && (
          <ApproverList
            approveType={9}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={formSchema?.checkButton}
            isLoading={isLoading}
            fetchButton={(disabled) =>
              formSchema?.fetchButton && (
                <FetchNewApprover
                  approveType={9}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginBottom: 10 }}
                  buttontext={formSchema?.fetchButton}
                  onSuccess={onSuccess}
                  disabled={disabled}
                />
              )
            }
            // contractModifyType={contractModifyType}
          />
        )}

        {formSchema?.cancelButton && (
          <CancelApprovalList
            approveType={9}
            projectversionId={projectId}
            style={{ marginRight: 10 }}
            buttontext={formSchema?.cancelButton}
            onSuccess={onSuccess}
          />
        )}

        <ConfirmWidget
          title={`ยืนยันการ${
            sendToGranteeVal
              ? formSchema?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
              : formSchema.buttonText
          }`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการ${
            sendToGranteeVal
              ? formSchema?.sendToGrantee?.buttonText || 'ส่งกลับให้ผู้รับทุนแก้ไข'
              : formSchema.buttonText
          }`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
